import { Injectable, signal, computed } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { apiEndpoints } from '../app/configs/api-endpoints.config';
import { ElofizetoCegVmForSelect } from '../models/elofizetoCeg.model';

const COOKIE_NAME = 'selectedCegGuid';
const COOKIE_EXPIRY_DAYS = 365;

@Injectable({
    providedIn: 'root',
})
export class ElofizetoCegService {
    private authEndpointUrl = apiEndpoints.auth;

    private _selectedCegGuid = signal<string | null>(this.getSelectedCeg());
    readonly selectedCegGuid = computed(() => this._selectedCegGuid());

    constructor(private http: HttpClient) {}

    getElofizetoCegek(): Observable<ElofizetoCegVmForSelect[]> {
        return this.http.get<ElofizetoCegVmForSelect[]>(`${this.authEndpointUrl}/elofizetoCegek`);
    }

    setSelectedCeg(guid: string): void {
        const expiryDate = new Date();
        expiryDate.setDate(expiryDate.getDate() + COOKIE_EXPIRY_DAYS);
        document.cookie = `${COOKIE_NAME}=${guid}; expires=${expiryDate.toUTCString()}; path=/; SameSite=Strict`;
        this._selectedCegGuid.set(guid);
        console.log('Cookie SAVED - selectedCegGuid:', guid);
    }

    getSelectedCeg(): string | null {
        const cookies = document.cookie.split(';');
        for (const cookie of cookies) {
            const [name, value] = cookie.trim().split('=');
            if (name === COOKIE_NAME) {
                return value || null;
            }
        }
        return null;
    }

    clearSelectedCeg(): void {
        const currentValue = this._selectedCegGuid();
        document.cookie = `${COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Strict`;
        this._selectedCegGuid.set(null);
        console.log('Cookie CLEARED - selectedCegGuid was:', currentValue);
    }

    hasSelectedCeg(): boolean {
        return this.getSelectedCeg() !== null;
    }
}
